import { createFileRoute } from "@tanstack/react-router";
import AdminWeekUnlocks from "@/pages/AdminWeekUnlocks";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/week-unlocks/")({
  component: () => (
    <RoleGate allow={['staff','viewer']} area="Week Unlocks"><AdminWeekUnlocks /></RoleGate>
  ),
});
